export enum CalcOperationType {
  Sum = 'sum',
  Subtraction = 'subtraction',
  Multiplication = 'multiplication',
  Division = 'division',
  Exponentiation = 'exponentiation',
  DivisionRemainder = 'remainder',
}
